// @ts-nocheck
import * as types from '../types';
import CashierService from '../../services/CashierService';
import TicketsService from '../../services/TicketsService';
import AppVersionService from '../../services/AppVersionService';
import MonitoringService from '../../services/MonitoringService';
import { setSettlementMarketsData } from './settlement';

export const changeUpdatePasswordModalVisibility = visible => ({
    type: types.UPDATE_PASSWORD_MODAL_VISIBILITY_CHANGED,
    payload: visible,
});

export const openTicketInfoModal =
    ({ ticketId, ticketCode }) =>
    async dispatch => {
        const { info, item: ticket } = await CashierService.getTicketInfo(ticketCode);

        if (!info.success) {
            return;
        }

        dispatch(
            changeTicketInfoModalProps({
                isVisible: true,
                ticket: { ...ticket, ticketId },
                unSavedTicket: { ...ticket, ticketId },
            }),
        );

        return ticket;
    };

export const changeTicketInfoModalProps = props => ({
    type: types.TICKET_INFO_MODAL_PROPS_CHANGED,
    payload: props,
});

export const blockTicketPayment = params => async (dispatch, getStore) => {
    const { info } = await TicketsService.blockTicketPayment(params);

    if (!info.success) return { info };

    const reduxStore = getStore();
    const { ticketInfoModalProps } = reduxStore.global;

    const updatedTicket = { ...ticketInfoModalProps.ticket, paymentBlock: params.block };

    dispatch(
        changeTicketInfoModalProps({
            ...ticketInfoModalProps,
            ticket: updatedTicket,
        }),
    );

    return { updatedTicket, info };
};

export const cancelTicket = values => async (dispatch, getStore) => {
    const reduxStore = getStore();
    const { ticket } = reduxStore.global.ticketInfoModalProps;
    const params = {
        ...values,
        ticketNumber: ticket.code,
        channel: ticket.channel,
    };
    const { info } = await TicketsService.cancelTicketPayment({ ...params });

    if (!info.success) return { info };

    const { info: ticketInfo, item: updatedModalTicket } = await CashierService.getTicketInfo(ticket.code);

    if (!ticketInfo.success) return { info };

    dispatch(
        changeTicketInfoModalProps({
            isVisible: true,
            ticket: updatedModalTicket,
        }),
    );

    return { info, updatedTicket: updatedModalTicket };
};

export const ticketSettlementRequestConfirm = values => async (dispatch, getStore) => {
    const reduxStore = getStore();
    const { unSavedTicket, ticket } = reduxStore.global.ticketInfoModalProps;

    const filteredBetline = unSavedTicket.betLines?.filter(betLine => betLine.isSettlementStatusChanged);

    const betLines = filteredBetline.map(betLine => ({
        id: betLine.betLineId,
        settlementStatus: betLine.settlementStatus,
        manuallySettled: betLine.manuallySettled,
    }));

    const params = {
        ...values,
        ticketId: ticket.betId,
        betLines,
        channel: ticket.channel,
    };

    const { info } = await MonitoringService.changeTicketSettlementStatus(params);

    if (!info.success) return { info };

    const { info: ticketInfo, item: updatedModalTicket } = await CashierService.getTicketInfo(ticket.code);

    if (!ticketInfo.success) {
        return { info };
    }

    dispatch(
        changeTicketInfoModalProps({
            isVisible: true,
            ticket: updatedModalTicket,
            unSavedTicket: {
                ...unSavedTicket,
                betLines: unSavedTicket.betLines.map(betLine => {
                    return { ...betLine, isSettlementStatusChanged: false };
                }),
            },
        }),
    );

    return { info, updatedTicket: updatedModalTicket };
};

export const changeErrorModalProps = props => ({
    type: types.ERROR_MODAL_PROPS_CHANGED,
    payload: props,
});

export const setAppVersion = version => ({
    type: types.APP_VERSION_CHANGED,
    payload: version,
});

export const fetchAppVersion = () => async dispatch => {
    try {
        const response = await AppVersionService.getAppVersion();

        const { info, item } = response;

        if (!info.success) {
            return;
        }

        const { version } = item;

        dispatch(setAppVersion(version));
    } catch (error) {
        console.error(error);
    }
};

export const getActionBlockData = () => async dispatch => {
    dispatch(setActionBlockFetching(true));

    const { items } = await TicketsService.getActionBlockData();

    if (items) {
        dispatch(setActionBlockData(items));
    }

    dispatch(setActionBlockFetching(false));
};

export const updateActionBlockData = actionData => (dispatch, getStore) => {
    const { type, active } = actionData;
    const actions = getStore().global.actionBlock.actions;

    const newActions = actions.map(action => {
        if (action.type !== type) return action;
        else return { type, active };
    });

    dispatch(setActionBlockData(newActions));
};

export const changeActionBlock = actionData => async dispatch => {
    dispatch(setActionBlockFetching(true));

    const { info } = await TicketsService.updateActionBlock(actionData);

    if (info.success) {
        dispatch(updateActionBlockData(actionData));
    }

    dispatch(setActionBlockFetching(false));

    return { info };
};

export const setActionBlockData = actions => ({
    type: types.ACTION_BLOCK_CHANGED,
    payload: actions,
});

export const setActionBlockFetching = isFetching => ({
    type: types.ACTION_BLOCK_FETCHING,
    payload: isFetching,
});

export const changeConfirmModalProps = payload => ({
    type: types.CONFIRM_MODAL_PROPS_CHANGED,
    payload: payload,
});

export const resetConfirmModalProps = () => ({
    type: types.CONFIRM_MODAL_PROPS_CHANGED,
    payload: {
        isVisible: false,
        shouldRefresh: false,
        title: '',
        successMessage: '',
        failMessage: '',
        placeholder: null,
    },
});

export const onConfirmMarketModalCancel = () => async (dispatch, getStore) => {
    const reduxStore = getStore();
    const { settlementParams } = reduxStore.settlement.markets;
    const newSettlementParams = { ...settlementParams };
    delete newSettlementParams.manuallySettled;
    delete newSettlementParams.settlementStatus;

    dispatch(resetConfirmModalProps());

    dispatch(
        setSettlementMarketsData({
            selectedMarkets: [],
            selectedSettlementStatus: [],
            selectedTicketType: 0,
            settlementParams: newSettlementParams,
        }),
    );
};

export const onTicketConfirmModalCancel = () => async (dispatch, getStore) => {
    const reduxStore = getStore();
    const { ticket } = reduxStore.global.ticketInfoModalProps;

    dispatch(resetConfirmModalProps());

    dispatch(
        changeTicketInfoModalProps({
            isVisible: true,
            unSavedTicket: ticket,
        }),
    );
};

export const changeCurrentPageTitle = page => ({
    type: types.CURRENT_PAGE_TITLE_CHANGED,
    payload: page,
});

export const changeTranslationMode = payload => ({
    type: types.TRANSLATION_MODE_CHANGED,
    payload,
});

export const setDownloadFileList = payload => ({
    type: types.DOWNLOAD_FILE_LIST_CHANGED,
    payload,
});

export const cancelDownloadFile = fileId => ({
    type: types.CANCEL_DOWNLOAD_FILE,
    payload: fileId,
});
